module.exports = __webpack_public_path__ + "static/img/pitch_black.91a7ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_black.png
// module id = RrAv
// module chunks = 94